var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.14412 0.00214395 3.36486 0.761421 2.05255 2.11125C0.740251 3.46109 0.00208434 5.29124 0 7.20019C0 10.1298 2.06763 12.5625 4.25775 15.1375C4.95075 15.9529 5.66825 16.7962 6.307 17.6495C6.38874 17.7585 6.49372 17.8469 6.61387 17.9076C6.73401 17.9684 6.86611 18 7 18C7.13389 18 7.26599 17.9684 7.38613 17.9076C7.50628 17.8469 7.61126 17.7585 7.693 17.6495C8.33175 16.7962 9.04925 15.9529 9.74225 15.1375C11.9324 12.5625 14 10.1298 14 7.20019C13.9979 5.29124 13.2597 3.46109 11.9474 2.11125C10.6351 0.761421 8.85588 0.00214395 7 0ZM7 9.90026C6.48082 9.90026 5.97331 9.7419 5.54163 9.44521C5.10995 9.14853 4.7735 8.72683 4.57482 8.23346C4.37614 7.74009 4.32415 7.19719 4.42544 6.67343C4.52672 6.14967 4.77673 5.66856 5.14384 5.29095C5.51096 4.91334 5.97869 4.65618 6.48789 4.552C6.99709 4.44782 7.52489 4.50129 8.00454 4.70565C8.4842 4.91001 8.89417 5.25608 9.18261 5.70011C9.47105 6.14413 9.625 6.66616 9.625 7.20019C9.625 7.91629 9.34844 8.60306 8.85616 9.10943C8.36387 9.61579 7.69619 9.90026 7 9.90026Z",
    fill: "url(#paint0_linear_3095_1770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3095_1770",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderWhiteIcon);
export default __webpack_public_path__ + "static/media/placeholder-white-icon.4690c674e343e605d1bc6572d896bb75.svg";
export { ForwardRef as ReactComponent };